import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import { SYSTEM_BANNER_FETCH } from '../../actions/systemBanner/systemBannerActionType'
import { systemBannerSet, systemBannerReset } from '../../actions/systemBanner'
import { userSignOut } from '../../actions/Auth'
import { APIGetRequest } from 'util/connection'
import { API_URL, API_HEADERS } from 'constants/ApiSetting'
import { getItems } from 'util/custom'

function* systemBannerFetchProcess(): any {
  try {
    const { access_token } = yield call(getItems, ['access_token'])
    API_HEADERS.headers.Authorization = `Bearer ${access_token}`
    const url = `${API_URL}/v1/pms/rpc/utility/system_alert/get`

    const response = yield APIGetRequest(url, API_HEADERS)

    if (response.status === 200) {
      const resultData = response.data?.result_data ?? null
      if (resultData !== null) {
        const resolveItem = (item: any) => {
          if (!item) return null
          return { type: item.type, message: item.message ?? '' }
        }
        yield put(systemBannerSet({
          system: resolveItem(resultData.system),
          property: resolveItem(resultData.property),
        }))
      } else {
        yield put(systemBannerReset())
      }
    } else {
      if (response.status === 403) {
        yield put(userSignOut())
      }
    }
  } catch (error) {
    yield put(systemBannerReset())
  }
}

function* watchSystemBannerFetch() {
  yield takeLatest(SYSTEM_BANNER_FETCH, systemBannerFetchProcess)
}

export default function* rootSaga() {
  yield all([fork(watchSystemBannerFetch)])
}
